import request from '../utils/request'

//提交身份证号绑定学生信息
export function bindStudentIdApi(data) {
  return request({
    method: 'post',
    url: '/api/wechat/user/bind',
    data
  })
}

//提交学生ID解绑学生信息
export function unbindStudentIdApi(data) {
  console.log(data)
  return request({
    method: 'get',
    url: `/api/wechat/user/unbind/${data.studentId}`,
    data
  })
}

